import React from 'react';

interface FuelGaugeProps {
  value: number; // km/L
  min?: number;
  max?: number;
  label: string;
}

const FuelGauge: React.FC<FuelGaugeProps> = ({ value, min = 0, max = 20, label }) => {
  // Clamp value
  const clampedValue = Math.min(Math.max(value, min), max);
  const percentage = ((clampedValue - min) / (max - min)) * 100;
  
  // SVG Arc calculations
  const radius = 80;
  const strokeWidth = 12;
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * (circumference / 2);

  // Color based on efficiency
  const getColor = () => {
    if (value >= 15) return '#4ade80'; // Green
    if (value >= 10) return '#fbbf24'; // Yellow
    return '#f87171'; // Red
  };

  return (
    <div className="fuel-gauge-container" style={{ position: 'relative', width: '160px', height: '100px', margin: '0 auto' }}>
      <svg height={radius * 2} width={radius * 2} style={{ transform: 'rotate(-180deg)', overflow: 'visible' }}>
        {/* Background Arc */}
        <circle
          stroke="rgba(255,255,255,0.1)"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference / 2} ${circumference}`}
          style={{ strokeDashoffset: 0 }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        {/* Progress Arc */}
        <circle
          stroke={getColor()}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference / 2} ${circumference}`}
          style={{ 
            strokeDashoffset,
            transition: 'stroke-dashoffset 0.5s ease-out, stroke 0.5s ease'
          }}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      <div style={{ 
        position: 'absolute', 
        bottom: '10px', 
        left: '0', 
        right: '0', 
        textAlign: 'center' 
      }}>
        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'white' }}>{value.toFixed(1)}</div>
        <div style={{ fontSize: '0.7rem', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>{label}</div>
      </div>
    </div>
  );
};

export default FuelGauge;
